import { BuiltinInstanceMemberValue } from '../BuiltinInstanceMemberValue';
export class BufferLength extends BuiltinInstanceMemberValue {
    emit(sb, node, options) {
        sb.emitHelper(node, options, sb.helpers.bufferLength);
        sb.emitHelper(node, options, sb.helpers.wrapNumber);
    }
}

//# sourceMappingURL=length.js.map
